import $ from 'jquery';

export default class PartTabs {
    constructor(isMobile = false) {
        this.isMobile = isMobile
        this.currentRequests = {};
        this.mainBlock = $('.parts-tabs');
        this.input = $('[data-ac-search="parts"]');
    }

    event() {
        this.mainBlock
            .on('click', '.block-part-types .show-all-part-type', this.handleShowAllPartType.bind(this))
            .on('click', '.block-part-types-search .show-all-part-type', this.handleShowAllPartTypeSearch.bind(this))
            .on('click', '.block-part-types .btn-part-type', this.handlePartTypeBtn.bind(this))
            .on('click', '.block-part-types-search .btn-part-type', this.handlePartTypeBtnSearch.bind(this))
            .on("click", "[data-part-group-expand]", this.handleExpandBlockPartType.bind(this))
            .on('mouseover', '[data-part-group-expand]', this.handleHoverPartTypeTitle.bind(this))
            .on('mouseout', '[data-part-group-expand]', this.handleBlurPartTypeTitle.bind(this))
            .on('input.query', '[data-ac-search="parts"]', this.handleInputSearch.bind(this))
            .on('submit', '#search-part-type', this.handleSearch.bind(this))
        ;
    }

    handleShowAllPartType(e) {
        const $elem = $(e.currentTarget)
        const $btn = this.mainBlock.find('.btn-part-type')

        this.mainBlock.find('.list-part-types').toggle(200, () => {
            if (this.mainBlock.find('.list-part-types').is(':visible')) {
                $btn.find('svg').addClass('rotate')
                $btn.addClass('light')
                $elem.text('Скрыть все')
            } else {
                $btn.find('svg').removeClass('rotate')
                $btn.removeClass('light')
                $elem.text('Показать все')
                this.mainBlock.find('.block-part-types').find('.part-tabs-title.active').trigger('click')
            }
            this.mainBlock.find('.block-part-types .list-part-types .list-part-types-items').removeClass('hide')
        });
    }

    handleShowAllPartTypeSearch() {
        this.#toggle()
    }

    handlePartTypeBtn(e) {
        const $elem = $(e.currentTarget);
        let currentBtnLightIndex = this.mainBlock.find('.btn-part-type.light').data('index');
        if (this.mainBlock.find('.btn-part-type.light').length === 4) {
            currentBtnLightIndex = -1
        }
        const index = $elem.data('index') ?? 0;

        this.mainBlock.find('[data-ac-search="parts"]').val('')

        this.#toggle()

        if (this.isMobile) {
            $elem.find('.icon-caret-down svg').toggleClass('rotate')
            $elem.parent().find('.list-part-types').toggle(200, () => {
                if ($elem.parent().find('.list-part-types').is(':visible')) {
                    $elem.addClass('light')
                } else {
                    $elem.removeClass('light')
                    this.mainBlock.find('.block-part-types').find('.part-tabs-title.active').trigger('click')
                }
            });
            return;
        }

        this.mainBlock.find(`.btn-part-type:not([data-index="${index}"])`).find('svg').removeClass('rotate')
        this.mainBlock.find('.btn-part-type').removeClass('light')
        // $elem.removeClass('light')
        this.mainBlock.find('.block-part-types .list-part-types .list-part-types-items').addClass('hide')
        this.mainBlock.find('.list-part-types').toggle(200, () => {
            if (this.mainBlock.find('.list-part-types').is(':visible')) {
                $elem.addClass('light')
                $elem.find('svg').addClass('rotate')
            } else {
                $elem.removeClass('light')
                $elem.find('svg').removeClass('rotate')
                this.mainBlock.find('.block-part-types').find('.part-tabs-title.active').trigger('click')
            }
            this.mainBlock
                .find(`.block-part-types .list-part-types .list-one-part-type[data-index="${index}"]`)
                .find('.list-part-types-items')
                .removeClass('hide')

            if (undefined !== currentBtnLightIndex && currentBtnLightIndex !== index) {
                $elem.trigger('click')
            }
        });
    }

    handlePartTypeBtnSearch(e) {
        let $elem = $(e.currentTarget);
        const index = Number($elem.data('index'));

        // if (this.isMobile) {
        //     // $elem.closest('div').find('hr').toggleClass('active')
        //     $elem.find('.icon-caret-down svg').toggleClass('rotate')
        //     $elem.parent().find('.list-part-types').toggle(200);
        //     return;
        // }

        this.mainBlock.find('[data-ac-search="parts"]').val('')
        this.mainBlock.find('.block-part-types-search').html('')
        // if ($elem.hasClass('light')) {
        //     this.mainBlock.find('.block-part-types .btn-part-type.light').trigger('click')
        // }
        // if (!$elem.hasClass('light') && this.mainBlock.find('.block-part-types .btn-part-type.light').length === 0) {
        //     console.info('test2: ' + $elem.data('index'))
        // this.mainBlock.find('.block-part-types .list-part-types .list-part-types-items').addClass('hide')
        if (!this.mainBlock.find(`.block-part-types .btn-part-type:eq(${index})`).hasClass('light')) {
            // this.mainBlock.find('.block-part-types .btn-part-type.light').trigger('click')
            this.mainBlock.find(`.block-part-types .btn-part-type:eq(${index})`).trigger('click')
        }
        this.#toggle()
    }

    handleExpandBlockPartType(e) {
        let elem = $(e.currentTarget);
        let list = elem.closest('.i-pos-pt').find('.part-tabs-expand');
        elem.closest('.i-pos-pt').find('.part-tabs-title').toggleClass('active')
        list.toggle(200, () => {
            if (list.is(':visible')) {
                elem.find('span svg').addClass('rotate').find('path').attr('fill', '#333');
            } else {
                elem.find('span svg').removeClass('rotate').find('path').attr('fill', '#B4B9BD');
            }
        });
    }

    handleHoverPartTypeTitle (e) {
        let elem = $(e.currentTarget);
        elem.addClass('hover')
        elem.find('span svg path').attr('fill', '#333');
    }

    handleBlurPartTypeTitle (e) {
        let elem = $(e.currentTarget);
        elem.removeClass('hover')
        if (!elem.hasClass('active')) {
            elem.find('span svg path').attr('fill', '#B4B9BD');
        }
    }

    handleInputSearch(e) {
        let $input = $(e.currentTarget);
        let q = $input.val();

        this.mainBlock.find('#search-part-type button.button').prop('disabled', false)

        if (q.length === 0) {
            this.mainBlock.find('#search-part-type button.button').prop('disabled', true)
            this.#toggle()
            this.mainBlock.find('.block-part-types-search').html('')
        }
    }

    handleSearch(e) {
        e.preventDefault()

        let form = $(e.currentTarget);
        let q = form.find('input').val();
        let $searchBlock = this.mainBlock.find('.block-part-types-search')

        if (q.length < 1) return;

        this.#clearRequest()

        $.ajax({
            url: '/q/parts_query',
            method: 'POST',
            data: {"q": q, "route": this.input.data('router')},
            beforeSend: (jqXHR, settings) => {
                this.currentRequests[settings.url] = jqXHR;
            }
        }).then((data) => {
            this.#toggle(false)
            $searchBlock.html(data)
            // $searchBlock.find(".part-tabs-expand").show();
            // $searchBlock.find('hr').toggleClass('active')
            $searchBlock.find('[data-part-group-expand]').trigger('click')
        }).catch((e) => {
            $searchBlock.html(e.responseText ?? 'Ошибка.')
            this.mainBlock.find('.block-part-types').removeClass('hide');
            this.mainBlock.find('.block-part-types-search').removeClass('hide');
            // console.info(e?.responseJSON?.error ?? 'Ошибка.')
        });
    }

    #toggle(flag = true) {
        if (flag) {
            this.mainBlock.find('.block-part-types').removeClass('hide');
            this.mainBlock.find('.block-part-types-search').addClass('hide');
        } else {
            this.mainBlock.find('.block-part-types').addClass('hide');
            this.mainBlock.find('.block-part-types-search').removeClass('hide');
        }
    }

    #clearRequest() {
        for (let i in this.currentRequests) {
            this.currentRequests[i].abort()
        }
    }
}
